export default __webpack_public_path__ + "static/media/noise_very_high_light.39c80979.svg";